import React, { useMemo } from 'react';
import { Box, Divider, Typography } from '@mui/material';
import OrderItem from './Items/OrderItem';
import AsnItem from './Items/AsnItem';
import B2BOrderItem from './Items/B2BOrderItem';
import CatalogItem from './Items/CatalogItem';
import InventoryItem from './Items/InventoryItem';
import makeStyles from '@mui/styles/makeStyles';
import { COLORS, TITLES_MAP } from './constants';
import { sortedResultWithScore } from './helper';

const useStyles = makeStyles((theme) => ({
  resultItem: {
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },
  selectedItem: {
    backgroundColor: COLORS.SELECTED_BG_COLOR,
  },
}));

const SearchResultContainer = ({ title, children }) => (
  <>
    <Box px={4} py={2}>
      <Typography variant="subtitle2">{title}</Typography>
      <Divider />
    </Box>
    {children}
  </>
);

const COMPONENTS_MAP = {
  ORDER: OrderItem,
  ASN: AsnItem,
  B2B_ORDERS: B2BOrderItem,
  CATALOGUE_PRODUCT: CatalogItem,
  INVENTORY_PRODUCT: InventoryItem,
};

const SearchResults = ({ results, onResultSelect, inputValue }) => {
  const classes = useStyles();
  const sortedResultsArray = useMemo(() => {
    if (!results) return [];

    return sortedResultWithScore(results);
  }, [results]);

  const renderItems = (items, Component) => {
    return items?.map((data, index) => (
      <Box
        px={4}
        py={1}
        key={`${data.id || index}`}
        className={classes.resultItem}
        onClick={() => onResultSelect(data)}
      >
        <Component data={data} />
      </Box>
    ));
  };

  return (
    <>
      {sortedResultsArray.map(({ type, items }) => {
        const Component = COMPONENTS_MAP[type];
        const title = TITLES_MAP[type] || type;

        if (!Component || !items?.length) return null;

        return (
          <SearchResultContainer key={type} title={title}>
            {renderItems(items, Component)}
          </SearchResultContainer>
        );
      })}
    </>
  );
};

export default SearchResults;
